import { Launch } from "@models/launch.model.ts";
import { httpRequest } from "../../http.ts";
import { LaunchSerializer } from "@models/serializers/launchSerializer.ts";

export class CommandGetEngagementLaunches {
  async run(engagementId: number) {
    const url = `${
      import.meta.env.VITE_API_PLATFORM_SERVICE_URL
    }api/v1/engagements/${engagementId}/launches/`;
    try {
      const response = await httpRequest<any>(url, { method: "GET" });
      return this.deserialize(response);
    } catch (error) {
      console.error("Error fetching data:", error);
      throw error;
    }
  }

  deserialize(data: any): Launch[] {
    return new LaunchSerializer().deserializeList(data);

  }
}
